import { observer } from "mobx-react";
import React, { useState } from "react";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";

import HistoryIcon from "@mui/icons-material/History";
import ShareIcon from "@mui/icons-material/Share";

import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import {
  ButtonGroup,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { Share } from "@giscon/ui.share/dist/share";
import HelpLink from "./HelpLink";
import AccordionPanel from "../components/AccordionPanel";

const StyledIconButton = styled((props) => (
  <IconButton
    sx={(theme) => ({
      color: `${theme.palette.brand?.blue} !important`,
      "&:hover": {
        color: "rgb(0, 76, 105) !important",
      },
    })}
    {...props}
  />
))({ padding: 5, minHeight: 0, minWidth: 0 });

const HistoryViewer = ({ CommunicationStore, style }) => {
  const [url, setUrl] = useState("");
  // console.debug(
  //   "[HistoryViewer] render - history length",
  //   RootStore.history?.length,
  //   RootStore.history?.map?.((h) => ({ hasLayer: h?.hasLayer, url: h?.url }))
  // );
  return (
    <AccordionPanel
      summary={
        <>
          <Typography>{"Verlauf"}</Typography>
          <HelpLink
            className="help-link"
            size="20px"
            url="/hauptfunktionen/werkzeugleiste/verlauf"
          ></HelpLink>
        </>
      }
    >
      <div>
        {/* {RootStore.history?.some((h) => h?.hasLayer) &&*/}
        {RootStore.history[0]?.hasLayer &&
          [...RootStore.history]
            .reverse() //revese reverses the acutal object, so a copy is needed
            .map((item, itemIndex) => {
              const card = (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      overflow: "hidden",
                      justifyContent: "space-between",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {Object.keys(item.labels).map((level) => {
                      return `${item.labels[level]} `;
                    })}
                  </div>
                  <div
                    style={{
                      flexGrow: 0,
                      width: item.url ? "65px" : "35px", //"100px" : "75px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                      marginTop: 4,
                    }}
                  >
                    <ButtonGroup
                      style={{ padding: 0 }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                      }}
                      onMouseUp={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {/* <IconButton
                    title="Löschen"
                    onClick={() => {
                      // needed cause its only observable.ref
                      const history = RootStore.history.concat([]);
                      history.splice(itemIndex, 1);
                      RootStore.history = history;
                    }}
                    classes={{ label: styles.iconButtonLabel }}
                    className={styles.iconButton}
                  >
                    <CloseIcon />
                  </IconButton> */}
                      {item.url && (
                        <StyledIconButton
                          title="teilen"
                          onClick={() => {
                            setUrl(item.url);
                          }}
                        >
                          <ShareIcon />
                        </StyledIconButton>
                      )}
                      <StyledIconButton
                        title="Zu diesem Verlaufeintrag springen"
                        onClick={() => {
                          CommunicationStore.addMessage({
                            to: "gotoHistory",
                            message: {
                              history: RootStore.history.concat([]), // copy of current history
                              index: itemIndex,
                              item,
                            },
                          });
                        }}
                      >
                        <HistoryIcon />
                      </StyledIconButton>
                    </ButtonGroup>
                  </div>
                </div>
              );
              return (
                <div key={JSON.stringify(item) + itemIndex}>
                  {!window.debugActive && (
                    <Paper
                      elevation={2}
                      style={{ marginBottom: 5, marginTop: 2, padding: 7 }}
                    >
                      {card}
                    </Paper>
                  )}
                  {window.debugActive && (
                    <Accordion>
                      <AccordionSummary>{card}</AccordionSummary>
                      <AccordionDetails
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <TableContainer
                          style={{ flexGrow: 1, overflow: "hidden" }}
                        >
                          <Table component="div">
                            <TableBody component="div">
                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`URL`}</TableCell>
                                <TableCell component="div" align="left">
                                  <input
                                    type="text"
                                    value={`${item.url}`}
                                    readOnly
                                    style={{ maxWidth: 120 }}
                                  />
                                </TableCell>
                              </TableRow>
                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`Extent`}</TableCell>
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`${item.xmin}, ${item.ymin} ; ${item.xmax}, ${item.ymax}`}</TableCell>
                              </TableRow>
                              {Object.keys(item.labels).map((level) => {
                                return (
                                  <TableRow component="div">
                                    <TableCell
                                      component="div"
                                      align="left"
                                    >{`${level}`}</TableCell>
                                    <TableCell
                                      component="div"
                                      align="left"
                                    >{`${item.labels[level]}`}</TableCell>
                                  </TableRow>
                                );
                              })}
                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`Hintergrundkarte`}</TableCell>
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`${item.basemap}`}</TableCell>
                              </TableRow>
                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`Layer-Deckkraft`}</TableCell>
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`${item.opacity}`}</TableCell>
                              </TableRow>

                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`Zusätzliche Layer`}</TableCell>
                                <TableCell component="div" align="left">{`${
                                  item.layers?.replace(/\|/gi, ", ") || "keine"
                                }`}</TableCell>
                              </TableRow>
                              <TableRow component="div">
                                <TableCell
                                  component="div"
                                  align="left"
                                >{`Geometrische Einschränkung`}</TableCell>
                                <TableCell component="div" align="left">{`${
                                  (item.entity &&
                                    item.source &&
                                    `${item.source}: ${item.entity}`) ||
                                  "keine"
                                }`}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  )}
                </div>
              );
            })}
        <Modal
          open={!!url}
          onClose={() => {
            setUrl("");
          }}
        >
          <Paper
            style={{
              position: "fixed",
              width: 350,
              height: 350,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#FFF",
              overflow: "hidden",
              padding: "50px",
            }}
          >
            <div style={{ position: "absolute", top: 5, right: 5 }}>
              <IconButton
                onClick={() => {
                  setUrl("");
                }}
              >
                <Close />
              </IconButton>
            </div>
            <Share
              size={350}
              style={{
                width: 350,
                height: 350,
              }}
              shareUrl={url}
              shareText={
                "Eine Karte des Niedersächsisches Klimainformationssystem"
              }
              shareTitle={"NIKLIS"}
              enableQrcode
              enableMailTo
              shortenerUrl={
                "https://urls.niedersachsen.de/yourls-api.php?signature=44d15ac09f&action=shorturl&format=json&url="
              }
              shortenerRequestOptions={{
                requestUrlGenerator: (url, data) => {
                  return url + encodeURIComponent(data);
                },
                getResultString: (response) => {
                  return new Promise((resolve, reject) => {
                    response
                      .json()
                      .then((json) => {
                        if (json.status === "success") {
                          resolve(json.shorturl);
                        } else {
                          reject(JSON.stringify(json));
                        }
                      })
                      .catch((e) => {
                        reject(e);
                      });
                  });
                },
              }}
            />
          </Paper>
        </Modal>
      </div>
    </AccordionPanel>
  );
};
export default observer(HistoryViewer);
